module.exports = __webpack_public_path__ + "static/media/galeryCoatings3.5b052a82.jpg";